export const projectDetailRepeat = [
  "Every Day",
  "Every Weekday",
  "Every Week",
  "Every Month",
  "Every Year",
];
